import { E } from '@angular/cdk/keycodes';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { sample } from 'rxjs';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { ListColumn } from 'src/app/models/list-column.model';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SharedService } from 'src/app/services/shared-service.service';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';

@Component({
  selector: 'app-support-tickets',
  templateUrl: './support-tickets.component.html',
  styleUrls: ['./support-tickets.component.css']
})
export class SupportTicketsComponent implements OnInit {

  accountName: string = '';
  addTicket: boolean = false;
  updateticket: boolean = false;
  viewTicket: boolean = false;
  viewcomment: boolean = false;
  allTickets: any[] = [];
  updateTicketId: string = '';
  showNoRecordsFounds: boolean = false;
  userId!: any;
  roleName!: string;
  totalEntries: number = 0;
  columns: ListColumn[] = [
    { name: 'S.No', property: 'srNo', visible: true, isModelProperty: false },
    { name: 'Ticket ID', property: 'ticketSequenceId', visible: true, isModelProperty: true, isText: true },
    { name: 'Account Type', property: 'role', visible: true, isModelProperty: true, isText: true },
    { name: 'Issue', property: 'issueRelated', visible: true, isModelProperty: true, isText: true },
    { name: 'Subject', property:'subject', visible: true, isModelProperty: true, isText: true},
    { name: 'Date Raised', property: 'createdOn', visible: true, isModelProperty: true, isText: true},
    { name: 'Status', property: 'ticketStatus', visible: true, isModelProperty: true, isText: true},
    { name: 'Email Id', property: 'email', visible: true, isModelProperty: true, isText: true},
  ] as ListColumn[];

  isStaff: boolean = false;
  viewedTicketPage: boolean = false;
  editedTicketPage: boolean = false;

  constructor(
    private spinnerService: SpinnerService,
    private sharedService: SharedService,
    private location: Location,
    private localStorageService: LocalStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService
  ) {
    spinnerService.showSpinner();
    this.userId = localStorageService.getItem('userId');
    this.accountName = this.localStorageService.getItem('accountName');
    this.roleName = this.localStorageService.getItem('roleName');
    if(this.roleName === 'SUPER_ADMIN') {
      this.roleName = 'SUPER_ADMIN'
      if (localStorageService.getItem('accountName') === 'Staff') {
        this.isStaff = true;
      }
    }
  }

  ngOnInit(): void {
    this.breadcrumbService.setBreadcrumbs([ 'Dashboard','Support Tickets' ]);    
    if(window.history.state && window.history.state.viewedTicketPage === true){
      this.viewedTicketPage = window.history.state.viewedTicketPage;
      this.updateTicketId = window.history.state.ticketId;
    } else {
      this.viewedTicketPage = false;
    }
    if(window.history.state && window.history.state.editedTicketPage === true){
      this.editedTicketPage = window.history.state.editedTicketPage;
      this.updateTicketId = window.history.state.ticketId;
    } else {
      this.editedTicketPage = false;
    }
    this.onRefresh();

    if (this.roleName === 'DISTRIBUTOR' || this.roleName === 'OEM' || this.roleName === 'USER') {
      const accountTypeColumn = this.columns.find(col => col.property === 'role');
      if (accountTypeColumn) {
        accountTypeColumn.visible = false;
      }
    } 
    this.getTicketsByCreatedById(this.userId);
  }

  
  getDateOnly(dateString: string): string {
    const date = new Date(dateString);
    const mm = `0${date.getMonth() + 1}`.slice(-2);
    const dd = `0${date.getDate()}`.slice(-2);
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }
  ticketStatusObj: any={
    'Open': 'Open',
    'Under Review': 'UnderReview',
    'In Progress': 'InProgress',
    'Closed': 'Closed',
    'Re open': 'ReOpen',
    'Cancel': 'Cancel'
  }

  getTickets() {
    this.sharedService.getTickets().subscribe((res: any) => {
      if (res?.data && res?.data.length > 0) {
        this.totalEntries=res.totalCount;
        this.allTickets = res.data;   
        this.allTickets.map((t: any) => {
          const modifiedStatus = Object.keys(this.ticketStatusObj).find((s: any) => t.ticketStatus.toLowerCase() === this.ticketStatusObj[s].toLowerCase());
          t.ticketStatus = modifiedStatus;
          t.createdOn = this.getDateOnly(t.createdOn);
        });
        this.showNoRecordsFounds = false; 
      } else {
        this.showNoRecordsFounds = true; 
      }
    });
  }

  getTicketsByCreatedById(userId: any) {
    if (this.roleName === 'SUPER_ADMIN') {
      if (this.accountName === 'Staff') { 
        this.sharedService.getAssignedTicketsByUserId(userId).subscribe((res: any) => {
          if (res?.data && res?.data.length > 0) {
            this.totalEntries=res.totalCount;
            this.allTickets = res?.data;
            this.allTickets?.map((t: any) => {
              const modifiedStatus = Object.keys(this.ticketStatusObj).find((s: any) => t.ticketStatus.toLowerCase() === this.ticketStatusObj[s].toLowerCase());
              t.ticketStatus = modifiedStatus;
              t.createdOn = new Date(t.createdOn).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              });
            });
            this.showNoRecordsFounds = false; 
          } else {
            this.showNoRecordsFounds = true; 
            this.totalEntries = res.totalCount;
          }
          this.onRefresh(); 
        });
      } else {
        this.getTickets();
        this.onRefresh(); 
      }
    } else {
      this.sharedService.getTicketsByCreatedById(userId).subscribe((res: any) => {
        if (res?.data && res?.data.length > 0) {
          this.totalEntries=res.totalCount;
          this.allTickets = res?.data;
          this.allTickets?.map((t: any) => {
            const modifiedStatus = Object.keys(this.ticketStatusObj).find((s: any) => t.ticketStatus.toLowerCase() === this.ticketStatusObj[s].toLowerCase());
            t.ticketStatus = modifiedStatus;
            t.createdOn = new Date(t.createdOn).toLocaleDateString('en-US', {
              day: 'numeric',
              month: 'numeric',
              year: 'numeric',
            });
          });
          this.showNoRecordsFounds = false; 
        } else {
          this.showNoRecordsFounds = true; 
          this.totalEntries = res.totalCount;
        }
      });
      this.onRefresh(); 
  }
  
  }

  deleteTicket(id: string) {
    this.sharedService.deleteTicket(id).subscribe((res: any)=>{
      this.getTicketsByCreatedById(this.userId);
    })
  }

  selectedRow(event: any) {
    const tmp = this.allTickets.find((t: any)=> t.id === event);
    this.addTicket = false;
    this.updateticket = false;
    this.viewTicket = true;
    this.viewcomment = true;
    this.updateTicketId = tmp.id;
    
    this.router.navigate([], {
      queryParams: { ticketId: tmp.id },
      queryParamsHandling: 'merge', 
      state:{
        viewedTicketPage: true,
        ticketId: tmp.id
      }
    });
  }



  selectedAction(event: any){
    switch (event.action) {
      case MweConstants.addAction:
        if(this.roleName === 'OEM') {
          this.router.navigate(['dashboard/oem/support/raise-a-ticket']);
        }else if(this.roleName === 'DISTRIBUTOR') {
          this.router.navigate(['dashboard/distributor/support/raise-a-ticket']);
        }else{
          this.router.navigate(['dashboard/super-admin/support-tickets/raise-a-ticket']);
        }
        break;
      case MweConstants.editAction:
          this.addTicket = false;
          this.updateticket = true;
          this.viewTicket = false;
          this.updateTicketId = event.row.id;
          
     break;

      default:
        break;
    }
  }
  onRefresh(): void {
    
    if(this.editedTicketPage){
      this.viewTicket = false;
      this.addTicket = false;
      this.updateticket = true;
    }
    if(this.viewedTicketPage) {
      
      this.viewTicket = true;
      this.addTicket = false;
      this.updateticket = false;
    }
    this.route.queryParams.subscribe((params) => {
      const ticketId = params['ticketId'];
      if (ticketId) {

        const interval = setInterval(() => {
          if (this.allTickets.length > 0) {
            clearInterval(interval); 
            const tmp = this.allTickets.find((t: any) => t.id === ticketId);
            if (tmp ) {

              this.addTicket = false;
              this.updateticket = false;
              this.viewTicket = true;
              this.updateTicketId = tmp.id;
            } else {
              this.resetState();
            }
          }
        }, 100); 
      } else {
        this.resetState();
      }
      this.spinnerService.hideSpinner();
    });
  }
  
  resetState(): void {
    this.addTicket = false;
    this.updateticket = false;
    this.viewTicket = false;
    this.updateTicketId = '';
  }

  cancel(event: any){
    this.updateticket = event[1];
    if(this.updateticket) {
      this.getTicketsByCreatedById(this.userId);
    }
    this.resetState();
  }
}
